import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './support-dashboard.component.html',
  styleUrls: ['./support-dashboard.component.css']
})
export class SupportDashboardComponent implements OnInit {

  constructor(private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
  }

loginAsProvider() {
  this.router.navigate([ '../accounts', {operation: 'login'} ], { relativeTo: this.route });
}
verify() {
  this.router.navigate([ '../accounts', {operation: 'verify'} ], { relativeTo: this.route });
}
}
